import React from 'react';
import getContent from 'pp-react-l10n';
import AppStore from '../../stores/AppStore';
import { withRouter } from 'react-router-dom';
import withTheme from '../../components/withTheme';
import templateData, { localsMessages } from '../../utility/getTemplateData';
import { hideSpinnerOverlay } from '../../utility/helper';
import { trackErrorPageIM } from '../../fpti/fpti';
import { PAGE_SPEC } from '../../fpti/fptiConstants';
import { addClass, removeClass } from '../../utility/domUtils';
import FullPageError from './FullPageError';

class PaymentError extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount = () => {
    addClass('#mainWrapper', ['full-page-error']);
    hideSpinnerOverlay();
    const ERROR_CODE = AppStore.getPaymentError() || '';
    trackErrorPageIM({
      pageSpec: PAGE_SPEC.GUEST_FAILURE_PAGE,
      errorCode: ERROR_CODE,
    });
  };

  componentWillUnmount() {
    removeClass('#mainWrapper', ['full-page-error']);
  }

  handleTryAgain = () => {
    this.props.history.push(`/donate?token=${templateData.token}`);
  };

  render() {
    const { error = {}, label = {} } = localsMessages('errors/paymentError');
    const ERROR_CODE = AppStore.getPaymentError() || '';

    let { WSM_CANNOT_PAY_SELF = '', WENT_WRONG, TEMP_GLITCH } = error;
    let { tryagain } = label;

    const hideButton = ERROR_CODE === 'WSM_PAYER_LIMIT_EXCEEDED';

    switch (ERROR_CODE) {
      case 'WSM_PAYMENT_DENIED':
        WENT_WRONG = error.DID_NOT_WORK;
        TEMP_GLITCH = error.DIFF_CREDIT_DEBIT;
        tryagain = label.trydiffcard;
        break;
      case 'WSM_CANNOT_PAY_SELF':
        const L2 =
          WSM_CANNOT_PAY_SELF &&
          WSM_CANNOT_PAY_SELF.replace(
            '{data.dataMerchant.name}',
            templateData.donationName
          );
        WENT_WRONG = error.WSM_CANNOT_PAY_SELF_H;
        TEMP_GLITCH = L2;
        break;
      case 'WSM_PAYER_LIMIT_EXCEEDED':
        WENT_WRONG = error.AmountLimitBreachError;
        TEMP_GLITCH = getContent('locals')('errors/paymentError')(
          'error.CustomerCareMessage',
          {
            customerServiceLink: '/selfhelp/home',
          },
          {
            useHTML: true,
          }
        );
        break;
      default:
        break;
    }

    return (
      <div>
        <FullPageError
          title={WENT_WRONG}
          body={TEMP_GLITCH}
          buttonLabel={hideButton ? null : tryagain}
          handleButtonClick={this.handleTryAgain}
          showCloseButton={true}
        />
      </div>
    );
  }
}

export default withRouter(withTheme(PaymentError));
